import { Popover as BasePopover } from "@base-ui/react/popover";

import type { ColorPickerBackdropProps } from "./ColorPicker.types";

export function ColorPickerBackdrop({ ...props }: ColorPickerBackdropProps) {
  return <BasePopover.Backdrop data-slot="color-picker-backdrop" {...props} />;
}
